import { ChangeDetectionStrategy, Component, Input, OnChanges, WritableSignal, computed, signal } from '@angular/core';

import { EpcotConfig, QuickBetConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { PickId } from '../../../../core/picks/pick-id';
import { isBetBuilderPick, isUnknownPickWithLegs } from '../../../../core/utils';
import { FreeBetToken, IRewardToken } from '../../../reward-tokens/reward-tokens.model';
import { isFreebetToken } from '../../../reward-tokens/services/reward-tokens.utils';
import { QuickBetActions } from '../../quick-bet-actions';
import { selectTrackingDetails } from '../../quick-bet.selectors';
import { QuickBetPickDetails, QuickBetPickDetailsService } from '../../services/quick-bet-pick-details.service';

@Component({
    selector: 'bs-quick-bet-picks-handler-container',
    templateUrl: './quick-bet-picks-handler-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-picks-handler-container.component.scss'],
    standalone: false,
})
export class QuickBetPicksHandlerContainerComponent implements OnChanges {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() set pickList(pickList: BetslipPick[]) {
        this.picks.set([...pickList]);
    }

    @Input() set singleBetId(singleBetId: PickId) {
        this.pickId.set(singleBetId);
    }

    selectTrackingDetails = this.store.selectSignal(selectTrackingDetails);

    vm$: Observable<QuickBetPickDetails | null>;

    picks: WritableSignal<BetslipPick[]> = signal([]);
    pickId: WritableSignal<PickId | undefined> = signal(undefined);
    pickIds = computed(() => this.picks().map((pick) => pick.id));
    isSinglePick = computed(() => this.picks().length === 1 && !isBetBuilderPick(this.picks()[0]) && !isUnknownPickWithLegs(this.picks()[0]));
    singlePick = computed(() => this.picks()[0]);

    isEpcotEnabled = this.epcotConfig.isEnabled;
    isQuickDepositOpen = false;

    constructor(
        private epcotConfig: EpcotConfig,
        private quickBetPickDetailService: QuickBetPickDetailsService,
        private store: Store,
        public quickBetConfig: QuickBetConfig,
        public sitecore: Sitecore,
    ) {}

    ngOnChanges(): void {
        this.vm$ = this.pickIds().length ? this.quickBetPickDetailService.model$ : of(null);
    }

    getEachWayValue(isEachway: boolean): string | void {
        if (isEachway) {
            return '2x';
        }
    }

    isFreeBetToken(token: IRewardToken | null): token is FreeBetToken {
        return isFreebetToken(token);
    }

    close(): void {
        this.store.dispatch(QuickBetActions.removePickButtonClick({ trackingDetails: this.selectTrackingDetails() }));
    }
}
